export const formatAccountNumber = (accountNumber: string) =>
  accountNumber.replaceAll('-', '')
